import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function CustomerIntentSvg({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <SvgIcon
            viewBox="0 0 20 20"
            sx={{ width: 20, height: 20, fill: "none", ...sx }}
        >
            <path
                d="M5 10C6.72589 10 8.125 8.60089 8.125 6.875C8.125 5.14911 6.72589 3.75 5 3.75C3.27411 3.75 1.875 5.14911 1.875 6.875C1.875 8.60089 3.27411 10 5 10Z"
                fill="currentColor"
                stroke="currentColor"
            />
            <path
                d="M14.375 10C16.7912 10 18.75 8.04125 18.75 5.625C18.75 3.20875 16.7912 1.25 14.375 1.25C11.9588 1.25 10 3.20875 10 5.625C10 8.04125 11.9588 10 14.375 10Z"
                fill="currentColor"
                stroke="currentColor"
            />
            <path
                d="M10 18.75C12.0711 18.75 13.75 17.0711 13.75 15C13.75 12.9289 12.0711 11.25 10 11.25C7.92893 11.25 6.25 12.9289 6.25 15C6.25 17.0711 7.92893 18.75 10 18.75Z"
                fill="currentColor"
                stroke="currentColor"
            />
        </SvgIcon>
    );
}
